import { updatedConstants, userConstatnt } from "../_constants/user.constant";

export const uservalueaction = {
    useraction, usermenuid
}

function useraction() {
    return { type: userConstatnt.USERDATA }
}
function usermenuid() {
    return { type: userConstatnt.MENUID }
}
function usermenuitems() {
    return { type: userConstatnt.MENUITEMS }
}

//#region set parameter true and false
export const updateActions = {
    updated, updatedclear
};
function updated() {
    return { type: updatedConstants.UPDATED };
}
function updatedclear() {
    return { type: updatedConstants.UPDATEDCLEAR }
}
//#endregion